import request from './base'

export default {
  /**
   * 查询消息
   * params: {
   *  pageNum: 1,
   *  pageSize: 10,
   *  dto: {
   *    status: 2,   2 正常，6未读，7已读，9 删除
   *    readType: 1  表示是谁看这个消息。1是后台管理员看2是给网站管理员或者个人看
   *   }
   * }
   */
  getNotice: (commit, payload, mutation) => {
    let options = request.getOptions('/notice/page', payload)
    return request.post(commit, options, mutation)
  },
  /**
   * 更新消息状态
   * params: {
   *  dto: {noticeId: 1}
   * }
   */
  updateNotice: (commit, payload, mutation) => {
    let options = request.getOptions('/notice', payload)
    return request.put(commit, options, mutation)
  }
}



// WEBPACK FOOTER //
// ./src/services/message.js